import { useEffect, useState } from "react";
import { ApiRequest } from "GlobalFunctions";
import { useSnackbar } from "notistack";
import 'assets/css/main.css';
import ISwitch from "elements/ISwitch";
import MenuTaxes from "../MenuTaxes";
import AutocompleteField from "elements/AutocompleteField";
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { PiGearThin } from "react-icons/pi";
import TaxSettingsEditor from "./TaxSettingsEditor";
import TaxExemptionsList from "./TaxExemptionsList";

const defaultValues = {
    is_included: false,
    default_tax_category_id: ''
};

export default function TaxSettings(props: any) {

    const { setLoading } = props;
    const { enqueueSnackbar } = useSnackbar();
    const [formValues, setFormValues] = useState<any>({});
    const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
    const [openEditor, setOpenEditor] = useState<boolean>(false);
    const [editingId, setEditingId] = useState<any>(null);
    const [refreshExemptions, setRefreshExemptions] = useState<number>(0);

    /*==========================================
    GET TAXES CONFIGURATION
    ==========================================*/
    const getTaxesConfiguration = async () => {
        await ApiRequest({
            method: 'GET',
            url: '/taxes/storeTaxesConfig',
            query: { store_id: localStorage.getItem('store_id') },
            setResponse: (res: any) => {
                setFormValues(res);
                setIsInitialLoad(false); // Mark that initial load is complete
            },
        });
        setLoading(false);
    }

    useEffect(() => {
        getTaxesConfiguration();
    }, []);
   

    /*==========================================
    UPDATE INCLUDED TAXES
    ==========================================*/
    const updateStoreTaxesConfig = (updatedValues: any) => {
        ApiRequest({
            method: 'POST',
            url: '/taxes/updateStoreTaxesConfig',
            body: { 
                store_id: localStorage.getItem('store_id'),
                ...updatedValues,
            },
            setResponse: (res: any) => {
                enqueueSnackbar("Included taxes updated successfully", { variant: "success" });
            }
        });
    }

    console.log("formValues", formValues);

    const handleOpenDialog = () => {
        setEditingId(null);
        setOpenEditor(true);
    }

    const handleEditSettings = (id?: any) => {
        setEditingId(id);
        setOpenEditor(true);
    }

    const handleCloseEditor = () => {
        setOpenEditor(false);
        setRefreshExemptions(prev => prev + 1); // Trigger refresh of exemptions list
    }

    return (
        <div className='ModuleContainer'>
            <div className="ModuleHeader">
                <div className="ComponentTitle">
                    <h1>Tax Settings</h1>
                </div>

                <MenuTaxes />

                <div className="ModuleActions">

                </div>
            </div>

            <div id='taxes_content' className='ModuleContent'>

                <span className="account_label">Tax Settings by Region</span>
                <p>Default tax rates are applied automatically. You can disable taxes for specific cities, Regions, Countries.</p>

                <div className="ModuleSection">

                <a 
                  onClick={handleOpenDialog}
                  className="addProductButton"
                >
                  Manage Tax Exemptions
                </a>
                    
                </div>

                <TaxExemptionsList refreshTrigger={refreshExemptions} />
            </div>
 
            <TaxSettingsEditor
                setLoading={setLoading}
                openEditor={openEditor}
                setOpenEditor={handleCloseEditor}
                id={editingId}
                loadList={getTaxesConfiguration}
            />
        </div>
    );
}
